// extracted by mini-css-extract-plugin
export default {"root":"SortLabel_root__PnXJ3","active":"SortLabel_active__u8LrK"};